import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getChatConfigUrl(assistantId) {
  return `/api/public-chat/${assistantId}`;
}
export function getWelcomeMessageUrl(assistantId) {
  return `/api/aiAssistant/${assistantId}`;
}
@Injectable({
  providedIn: "root"
})
export class KnolliChatService extends  TaxplanIQServices{
  constructor(http: HttpClient) {
    super(http);
  }

  getChatConfig(assistantId: number, obj): Observable<any> {
    const url = getChatConfigUrl(assistantId);
    return this.create(url, obj, SOURCE_TYPE.KNOLLI).pipe(catchError(this.handleError));
  }

  getWelcomeMessage(assistantId: number){
    const url = getWelcomeMessageUrl(assistantId);
    return this.query(url, SOURCE_TYPE.KNOLLI).pipe(catchError(this.handleError));
  }

  getLatestMessageId(chatId: number): Observable<any> {

    const url = `/api/getUser-messageId-v2?chatId=${chatId}`;

    return this.query(url, SOURCE_TYPE.KNOLLI).pipe(catchError(this.handleError));

  }

  rateMessage(messageId: number, rating: 1 | -1 | 0, userFeedback?: string): Observable<any> {

    const url = `/api/user-rating/${messageId}`;

    const body: any = { id: messageId, userRating: rating };
    if (userFeedback) body.userFeedback = userFeedback;

    return this.create(url, body, SOURCE_TYPE.KNOLLI)

      .pipe(catchError(this.handleError));

  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }
}
